import { cn } from '@bw/core';
import { ContentfulLivePreview } from '@contentful/live-preview';
import { MouseEventHandler } from 'react';
import { Block } from '../../factories/types';
import { NavigationSuppressor } from '../../live-preview/NavigationSuppressor';
import styles from './Page.module.scss';


export const PageLivePreview: Block<'page'> = ({
  data: {
    fields: { header, sections, footer },
  },
  render,
}) => {
  const onClickCapture: MouseEventHandler<HTMLDivElement> = e => {
    e.preventDefault();
    e.stopPropagation();
    if (header) {
      ContentfulLivePreview.openEntryInEditor({
        entryId: header.sys.id,
        fieldId: '.'
      })
    }
  }

  return (
    <NavigationSuppressor>
      <div className={cn(styles.page, 'new-layout')}>
        <div onClickCapture={onClickCapture}>
          {render(header)}
        </div>
        <main>
          {/* TODO(amatlash): make it type safe */}
          {/* @ts-ignore */}
          {render(sections)}
          {render(footer)}
        </main>
      </div>
    </NavigationSuppressor>
  );
};
